import React, { useCallback, useMemo } from 'react';

import styled, { css } from 'styled-components';

import FilterTransactions from '@components/FilterTransactions';
import { useRefund, useTransaction, useAuth, useWidth } from '@hooks';

import TransactionsWeb from './TransactionsWeb';

const Sticky = styled.div(
  ({ theme, mobile }) =>
    css`
      background: ${theme.colors.gray100};
      padding: ${mobile ? `16px 0px` : `20px 0`};
      position: -webkit-sticky; /* Safari */
      position: sticky;
      z-index: 1;
      top: 0px;
    `
);

const Transactions = () => {
  const { isOnus } = useAuth();
  const width = useWidth();
  const { getDetail } = useTransaction();
  const { getRefunds } = useRefund();

  const handleDetail = useCallback((data) => {
    getRefunds(data.sale_authorization_id, data.event_date);
    getDetail(data);
  }, []);

  const mobile = useMemo(() => width < 960, [width]);

  return (
    <>
      <Sticky {...{ mobile }}>
        <FilterTransactions falabella={!isOnus} htmlIdReportButton="download-transaction-report" />
      </Sticky>
      <TransactionsWeb handleDetail={handleDetail} falabella />
    </>
  );
};

export default Transactions;
